import React from 'react';
import clsx from 'clsx';
import './GeneralCTA.scss';

interface GeneralCTAProps {
  className?: string;
}

const GeneralCTA: React.FC<GeneralCTAProps> = ({ className }) => {
  return <div className={clsx('general-cta', className)} />;
};

export default GeneralCTA;
